import React from 'react';
import moment from 'moment';
import { Popover, PopoverBody } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { baseUrl } from '../url';
import $ from 'jquery';

class EventDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            popoverOpen: false,
            edit: false,
            time: moment(this.props.event.start).format('HH:mm:ss'),
            date: moment(this.props.event.start).format('YYYY-MM-DD'),
            description: this.props.event.description,
            appointment_id: this.props.event.id,
            response: true,
            success: false, 
        };
    }
    componentDidMount(){
        $(function () {
            $('[data-toggle="popover"]').popover()
        })
    }
    toggle = () => {
        this.setState(() => {
            return {popoverOpen: !this.state.popoverOpen,}
        });
    }
    openPatientProfile = (id) => {
        localStorage.setItem('user_id', JSON.stringify(id));
        this.props.history.push(`/patient`);
    }
    
    handleChange = (e) => {
        this.setState({ 
            [e.target.name]: e.target.value,
            [e.target.name + 'Error']: ''
        });

        if(e.target.name === 'date'){
            let date  = moment(e.target.value).format('YYYY-MM-DD')
            this.setState({
                date
            })
        }
        if(e.target.name === 'time'){
            let time = moment(e.target.value, 'HH:mm').format('HH:mm:ss')
            this.setState({
                time
            })
        }
    }

    editAppointment = () => {
        this.setState({ edit: true });
    };

    hideModal = () => {
        this.setState({ show: false });
    };

    handleEdit = (e) => {
        e.preventDefault();
        const {date, time, description } = this.state;
        if(!date){
            this.setState({
                dateError: 'Please enter a valid date'
            })
        }
        if(!time){
            this.setState({
                timeError: 'Please enter appointment time'
            })
        }
        if(!description){
            this.setState({
                descriptionError: 'Please write a decription'
            })
        }
        if(date && time && description){
            this.setState({
                response: false
            })
            const token = localStorage.getItem('access_token');
            const { appointment_id } = this.state;
            let retries = 0;
            let entry = {
                date,
                time,
                description,
            };
            fetch(`${baseUrl}/admin/patients/appointments/${appointment_id}`,{
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': token,
                },
                body: JSON.stringify(entry)
            })
            .then(response => {
                const auth = response.headers.get('Authorization');
                localStorage.setItem('access_token', auth);
                return response.json();
            })
            .then(responseJson => {
                this.setState({
                    response: true
                })
                if (responseJson.hasOwnProperty('_meta')){
                   if(responseJson._meta._status === 202){
                       this.setState({
                           success: true,
                           message: responseJson.message
                       }, () => {
                           setTimeout(() => {
                                this.toggle();
                                this.setState({
                                    edit: false,
                                    success: false,
                                })
                           }, 1000);   
                       })
                   }
                }
            })
            .catch((error) => {
                if (error === 401 && retries < 1) {
                    localStorage.getItem('access_token')
                        .then(value => {
                            fetch(`${baseUrl}/token/refresh`, {
                                headers: {
                                    'Accept': 'application/json',
                                    'Authorization': value
                                }
                            }).then(response => {
                                retries += 1;
                                if (response.status === 200) {
                                    localStorage.setItem('access_token', response.headers.get('Authorization'));
                                    this.handleSubmit();
                                }
                                else {
                                    alert('something went wrong please try again later');
                                }
                            })
                        })
                }
                else {
                    alert('something went wrong please try again later');
                }
            })
        }
    }

    render() {
        const { event } = this.props;
        const { edit, success } = this.state;
        const start = moment(event.start);
        const end = moment(event.end);
        const duration = end.diff(start, 'hours');
        return (
            <React.Fragment>
                <div>
                    <button
                        style={{
                            backgroundColor: 'transparent',
                            color: '#FFFFFF',
                            height: '100%',
                            width: 'auto',
                            border: 'none',
                        }}
                        id={`Popover${event.id}`}
                        type="button"
                        onClick={() => this.toggle()}>
                        {event.title}
                    </button>
                    <Popover trigger="legacy" placement="bottom" isOpen={this.state.popoverOpen} target={`Popover${event.id}`} toggle={this.toggle}>
                        <PopoverBody>
                            {
                                !edit &&
                                <React.Fragment>
                                    <div className="popover-item-top">
                                        <p
                                            onClick={() => this.openPatientProfile(event.patient_id)}>
                                            {event.patient_name}
                                        </p>
                                        <i className="fa fa-pencil" onClick={this.editAppointment} />
                                    </div>
                                    <div className="popover-item-body">
                                        <h6>{event.description}</h6>
                                        <p>Duration: {duration} hour</p>
                                    </div>
                                </React.Fragment>
                            }
                            {
                                edit &&
                                <React.Fragment>
                                    {
                                        !success &&
                                        <div className="popover-item-body">
                                            <h6>Edit Appointment for {event.patient_name}</h6>
                                            <label>
                                                Date
                                                <input type="date" onChange={this.handleChange} value={this.state.date} name="date" className={this.state.dateError ? 'error-input' : ''} />
                                                <span className="error-text">{this.state.dateError}</span>
                                            </label>
                                            <label>
                                                Time
                                                <input type="time" onChange={this.handleChange} value={this.state.time} name="time" className={this.state.timeError ? 'error-input' : ''} />
                                                <span className="error-text">{this.state.timeError}</span>
                                            </label>
                                            <label>
                                                Description
                                                <textarea onChange={this.handleChange} name="description" value={this.state.description} className={this.state.descriptionError ? 'error-input' : ''}></textarea>
                                                <span className="error-text">{this.state.descriptionError}</span>
                                            </label>
                                            <button onClick={this.handleEdit}>
                                                Save
                                                {
                                                    !this.state.response &&
                                                    <i className="fa fa-spinner fa-pulse fa-fw" />
                                                }
                                            </button>
                                        </div>
                                    }
                                    {
                                        success &&
                                        <div className="check">
                                            <div className="svg-div">
                                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                                                    <circle className="path circle" fill="none" stroke="#14DA9E" strokeWidth="6" strokeMiterlimit="10" cx="65.1" cy="65.1" r="62.1" />
                                                    <polyline className="path check" fill="none" stroke="#14DA9E" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
                                                </svg>
                                            </div>
                                            <p><small>{this.state.message}</small></p>
                                        </div>
                                    }
                                </React.Fragment>
                            }
                        </PopoverBody>
                    </Popover>
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(EventDetails);


// WEBPACK FOOTER //
// ./src/components/appointments/EventDetails.js